var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-5",attrs:{"elevation":"0"}},[(_vm.selectedFile.name.endsWith('.pdf'))?_c('vue-pdf-embed',{attrs:{"source":_vm.fileSrc}}):(_vm.selectedFile.name.endsWith('.jpeg' || '.jpg' || '.png'))?_c('v-img',{attrs:{"src":_vm.fileSrc}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }